export default "__VITE_ASSET__d78e98ae__"